import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import AppRoutes from './AppRoutes';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollButton from './components/ScrollButton';
import CookieBanner from './components/CookieBanner';
import RouteTracker from './components/RouteTracker';
import initialDataContext from './contexts/initialDataContext';
import './index.css';

const initialData = window.__INITIAL_DATA__ || null;

// Remove the prerendered skeleton once the app hydrates.
const hideSkeleton = () => {
  const overlay = document.getElementById('loading-overlay');
  if (overlay) {
    overlay.classList.add('hide');
    setTimeout(() => overlay.remove(), 450);
  }
};

hydrateRoot(
  document.getElementById('root'),
  <initialDataContext.Provider value={initialData}>
    <HelmetProvider>
      <BrowserRouter>
        <App>
          <ScrollToTop />
          <Navbar />
          <AppRoutes />
          <Footer />
          <ScrollButton />
          <RouteTracker />
          <CookieBanner />
        </App>
      </BrowserRouter>
    </HelmetProvider>
  </initialDataContext.Provider>
);

hideSkeleton();
